import CompatDropzone from '../components/shared/CompatDropzone.vue'

// Legacy `vueDropzone` adı CompatDropzone'dur (Aşama 4.5, dropzone-vue). Eager: FileUpload `$refs.myDropzone.dropzone`'a
// `mounted`'da erişir.
export default {
  install(app) {
    app.component("vueDropzone", CompatDropzone)
  }
}
